import React, { useEffect } from "react";
import "./modal.scss";

const CustomModal = (props: {
  visible?: boolean;
  onHide: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: any;
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && props.visible) {
        props.onHide();
      }
    };

    if (props.visible) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [props.visible, props.onHide]);

  if (!props.visible) {
    return null;
  }

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      props.onHide();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-header">
          {props.header && <div className="modal-header-content">{props.header}</div>}
          <button className="modal-close-button" onClick={props.onHide} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body">{props.children}</div>
        {props.footer && <div className="modal-footer">{props.footer}</div>}
      </div>
    </div>
  );
};

export default CustomModal;
